"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.updateAll = exports.create = exports.moveToXY = exports.reset = exports.setColor = exports.getByGamepadNumber = exports.createAll = exports.getAll = void 0;
var crokinoleGamepad_sidecar_1 = require("@crokinole/input/crokinoleGamepad-sidecar");
var crokinoleCamera_sidecar_1 = require("@crokinole/main/crokinoleCamera-sidecar");
var spritesUiGame_1 = require("@crokinole/recyclers/spritesUiGame");
var diveColors_1 = require("@dive/colors/diveColors");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var chroma_js_1 = __importDefault(require("chroma-js"));
var cursorHideSeconds = 5;
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
var createAll = function () {
    for (var i = 1; i <= crokinoleGamepad_sidecar_1.crokinoleGamepad.maxGamepads; i++) {
        exports.create(i);
    }
};
exports.createAll = createAll;
var getByGamepadNumber = function (gamepadNumber) {
    for (var i = 0; i < objs.length; i++) {
        if (objs[i].gamepadNumber === gamepadNumber) {
            return objs[i];
        }
    }
    return null;
};
exports.getByGamepadNumber = getByGamepadNumber;
var setColor = function (gp, color) {
    gp.color = chroma_js_1.default(color).darken(1.5).num();
};
exports.setColor = setColor;
var reset = function () {
    for (var i = 0; i < objs.length; i++) {
        var obj = objs[i];
        obj.physicsX = 0;
        obj.physicsY = 0;
    }
};
exports.reset = reset;
var moveToXY = function (obj, physicsX, physicsY) {
    obj.physicsX = physicsX;
    obj.physicsY = physicsY;
};
exports.moveToXY = moveToXY;
var create = function (gamepadNumber) {
    var obj = {
        eType: 'voy-misc',
        id: 0,
        idLoaded: 0,
        isDead: false,
        isVisible: false,
        hideTimerSeconds: 0,
        gamepadNumber: gamepadNumber,
        physicsX: 0,
        physicsY: 0,
        color: diveColors_1.diveColors.pureWhite,
    };
    objs.push(obj);
    return obj;
};
exports.create = create;
var updateAll = function () {
    // Render each cursor
    for (var i = 0; i < objs.length; i++) {
        var obj = objs[i];
        exports.update(obj);
    }
};
exports.updateAll = updateAll;
var update = function (obj) {
    var gpi = crokinoleGamepad_sidecar_1.crokinoleGamepad.getInput(obj.gamepadNumber);
    // Unhide
    if (!crokinoleGamepad_sidecar_1.crokinoleGamepad.isAxisInDeadzone(gpi.axis2X, gpi.axis2Y)) {
        var gamepadSpeed = 0.05;
        obj.isVisible = true;
        obj.hideTimerSeconds = 0;
        obj.physicsX += gpi.axis2X * gamepadSpeed;
        obj.physicsY += -gpi.axis2Y * gamepadSpeed;
    }
    // Hide
    if (obj.isVisible) {
        obj.hideTimerSeconds += common_sidecar_1.common.getUpdateDelta();
        if (obj.hideTimerSeconds >= cursorHideSeconds) {
            obj.isVisible = false;
        }
    }
    // Bound
    var maxGamepad = 5.5;
    obj.physicsX = mathUtils_sidecar_1.mathUtils.clamp(obj.physicsX, -maxGamepad, maxGamepad);
    obj.physicsY = mathUtils_sidecar_1.mathUtils.clamp(obj.physicsY, -maxGamepad, maxGamepad);
    // Render
    if (obj.isVisible) {
        var wp = crokinoleCamera_sidecar_1.crokinoleCamera.physicsToWorld(obj.physicsX, obj.physicsY);
        var img = spritesUiGame_1.spritesUiGame.getNext(wp.x, wp.y, sprites_sidecar_1.sprites.crokinoleBoundary[0]);
        img.tint = obj.color; //diveColors.green
        diveFont_sidecar_1.diveFont.writeAbsolute(wp.x, wp.y, 'GP-' + obj.gamepadNumber, 0.5, obj.color);
    }
};
exports.update = update;
